import { Disclosure } from "@headlessui/react";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import { FaqQuesAndAnsData } from "./faqQuesAndAnsData";

export default function FaqQandACandidateComponent({
  faqs,
  hasAssessmentRecOrgs
}: {
  faqs: FaqQuesAndAnsData[];
  hasAssessmentRecOrgs?: boolean;
}) {
  const renderFaq = hasAssessmentRecOrgs ? faqs.slice(0, -1) : faqs;
  return (
    <div className="w-full">
      <div className="divide-y divide-gray-900/10">
        <dl className="mt-10 space-y-6 divide-y divide-gray-900/10">
          {renderFaq.map((faq, idx) => (
            <Disclosure as="div" key={idx} className="pt-6">
              {({ open }) => (
                <>
                  <dt>
                    <Disclosure.Button
                      className="flex w-full items-start justify-between text-left text-secondary"
                      data-testid={`faq${idx}Btn`}
                    >
                      <span className="text-base font-medium leading-7">
                        {faq.question}
                      </span>
                      <span className="ml-6 flex h-7 items-center">
                        {open ? (
                          <MinusIcon className="h-6 w-6" aria-hidden="true" />
                        ) : (
                          <PlusIcon className="h-6 w-6" aria-hidden="true" />
                        )}
                      </span>
                    </Disclosure.Button>
                  </dt>
                  <Disclosure.Panel
                    as="dd"
                    className="mt-2 pr-16 pl-1 space-y-2 text-sm sm:text-base text-gray-500 dark:text-gray-400"
                  >
                    {faq.answer.map((part, i) => {
                      if (typeof part === "string") {
                        return <p key={i}>{part}</p>;
                      }

                      const elements = [];

                      if (part.firstSentence) {
                        elements.push(
                          <p key={`first-${i}`}>{part.firstSentence}</p>
                        );
                      }

                      if (part.list) {
                        elements.push(
                          <ul
                            key={`list-${i}`}
                            className="list-disc pl-5 space-y-1"
                          >
                            {part.list.map((item, j) => (
                              <li key={j}>{item}</li>
                            ))}
                          </ul>
                        );
                      }

                      if (part.lastSentence) {
                        elements.push(
                          <p key={`last-${i}`}>{part.lastSentence}</p>
                        );
                      }

                      return elements;
                    })}
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          ))}
        </dl>
      </div>
    </div>
  );
}
